module.exports = __webpack_public_path__ + "static/media/v7m.8d66b49c.mp4";